import React, { useState } from "react";

export interface LinkItem {
    id: string;
    url: string;
    // title: string;
}

interface LinkManagerProps {
    links: LinkItem[];
    onLinksChange: (links: LinkItem[]) => void;
}

export const LinkManager: React.FC<LinkManagerProps> = ({
    links,
    onLinksChange,
}) => {
    const [newUrl, setNewUrl] = useState("");
    // const [newTitle, setNewTitle] = useState("");
    const [isAdding, setIsAdding] = useState(false);

    const addLink = () => {
        if (!newUrl.trim()) return;

        const newLink: LinkItem = {
            id: Date.now().toString(),
            url: newUrl.trim(),
            // title: newTitle.trim() || new URL(newUrl).hostname,
        };

        onLinksChange([...links, newLink]);
        setNewUrl("");
        // setNewTitle("");
        setIsAdding(false);
    };

    const removeLink = (id: string) => {
        onLinksChange(links.filter((link) => link.id !== id));
    };

    const isValidUrl = (url: string) => {
        try {
            new URL(url);
            return true;
        } catch {
            return false;
        }
    };

    return (
        <div>
            <p className="text-sm dark:text-white my-0 email-label-dv mb-4"><b>Links</b></p>

            {!isAdding && (
                <button className="cursor-pointer [border:none] py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue" onClick={() => setIsAdding(true)}> <span className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">Add Link</span> </button>
            )}

            {/* Existing Links */}
            {links.length > 0 && (
                <div className="grid w-full overflow-y-auto max-h-[140px]">
                    {links.map((link) => (
                        <div className="relative mt-2" key={link.id} style={{ border: "1px solid #ccc", padding: "4px" }}>
                            <div>
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {/* {link.title} */}
                                </a>
                                <p className="my-0 dark:text-white text-sm pr-5">{link.url}</p>
                            </div>  
                            {/* <button onClick={() => removeLink(link.id)}>Remove</button> */}
                            <button
                                type="button"
                                onClick={() => removeLink(link.id)}
                                className="absolute top-[1px] bottom-0 right-1 h-6  w-6 red-clockout-btn-dv bg-red cursor-pointer rounded-full py-[1px] px-[1px] shadow hover:bg-red-100 z-10"
                                title="Remove image"
                            >
                                <span className="text-red-500 font-bold text-lg text-white">×</span>
                            </button>
                        </div>
                    ))}
                </div>
            )}

            {/* Add Link Form */}
            {isAdding && (
                <div style={{ border: "1px solid #ccc", padding: "8px", marginTop: "10px" }}>
                    <div className="inputborder_css_dv linkmanager_inputborder_css_dv mt-id-dv self-stretch shadow-[0px_1px_2px_rgba(16,_24,_40,_0.05)] rounded-radius-md bg-text-text-tertiary overflow-hidden flex flex-row items-center justify-start py-2.5 px-[15px] dark:bg-slate-700 border-[1px] border-solid  border-surface-border undefined ">
                        <input
                            type="text"
                            placeholder="Enter URL (e.g., https://example.com)"
                            value={newUrl}
                            onChange={(e) => setNewUrl(e.target.value)}
                        />
                    </div>
                    <br />
                    {/* <input
                        type="text"
                        placeholder="Link title (optional)"
                        // value={newTitle}
                        onChange={(e) => setNewTitle(e.target.value)}
                    /> */}
                    <br />
                    <div className="self-stretch flex flex-row items-center justify-end py-0 pr-0 gap-[8px] mq950:box-border mq1425:flex-wrap  mq1425:box-border mq450:box-border">
                       
                    <button className="cursor-pointer bg-white py-2.5 h-[44px] mq575:h-[35px] px-[42px] btn-text-purple mq575:py-[12.5px] mq575:px-[25px] rounded-radiuscomponent-button box-border flex flex-row items-center justify-center gap-[12px] border-[2px] border-solid border-surface-primary-surface hover:bg-gainsboro-100 hover:box-border hover:border-[2px] hover:border-solid hover:border-dodgerblue"
                        onClick={() => {
                            setIsAdding(false);
                            setNewUrl("");
                            // setNewTitle("");
                        }}
                    >
                       <div className="relative text-sm font-body-xs-semi-bold dark:text-white text-center inline-block"> Cancel</div>
                    </button>
                     <button className="cursor-pointer [border:none]  py-2.5 h-[44px] mq575:h-[35px] px-[42px] mq575:py-[12.5px] mq575:px-[25px] bg-surface-primary-surface rounded-radiuscomponent-button flex flex-row items-center justify-center gap-[12px] hover:bg-dodgerblue  "
                        onClick={addLink}
                        disabled={!newUrl.trim() || !isValidUrl(newUrl.trim())}
                    >
                       <div className="relative text-sm font-body-xs-semi-bold text-surface-bg-primary text-center inline-block">
                         Add
                       </div>
                    </button>
                    </div>
                </div>
            )}
        </div>
    );
};
